<ag1-button
  [disabled]="items.length === 0 || disabled"
  [variant]="variant"
  (clickEvent)="onDropdownTriggerClick($event)"
>
  @if (isLoading) {
    <ag1-loader
      class="scale-[0.4]"
      classOverrides="!border-4 border-t-slate-800"
    />
  }
  @if (!isLoading) {
    <svg-icon src="/assets/icons/general/download.svg" />
  }
  {{ label }}
  <svg-icon class="ml-auto" src="/assets/icons/general/chevron-down.svg" />
</ag1-button>

<p-popover #dropdownPopover styleClass="[&_.p-popover-content]:!p-0">
  <ul class="min-w-[200px] overflow-hidden rounded">
    @if (isGrouped) {
      @for (key of groupKeys; track key) {
        <p class="px-3 py-2 font-semibold">
          {{ key | humanize }}
        </p>
        @for (groupedItem of groupedItems[key]; track groupedItem.value) {
          <li
            (click)="onClick(groupedItem)"
            class="cursor-pointer overflow-hidden overflow-ellipsis whitespace-nowrap px-3 py-2 hover:bg-steel-blue-600 hover:text-white"
            [class]="
              groupedItem === selectedItem ? 'bg-steel-blue-600 text-white' : ''
            "
          >
            {{ groupedItem.label }}
          </li>
        }
      }
    }

    @if (!isGrouped) {
      @for (item of items; track item.value) {
        <li
          (click)="onClick(item)"
          class="cursor-pointer overflow-hidden overflow-ellipsis whitespace-nowrap px-3 py-2 hover:bg-steel-blue-600 hover:text-white"
          [class]="item === selectedItem ? 'bg-steel-blue-600 text-white' : ''"
        >
          {{ item.label }}
        </li>
      }
    }
  </ul>
</p-popover>
